import React, { useState } from "react";
import AudioSlider from "../componments/SliderComponment.jsx";
import { SliderManager } from "../operators/SliderOperator.jsx";


import musicIcon from "../img/music.png";
import effectsIcon from "../img/effect.png";
import masterIcon from "../img/master.png";

const AudioControls = () => {
  const [music, setMusic] = useState(50);
  const [effects, setEffects] = useState(50);
  const [master, setMaster] = useState(50);

  const handleChange = (type, value) => {
    if (type === "music") setMusic(value);
    if (type === "effects") setEffects(value);
    if (type === "master") {
      setMaster(value);
      setMusic(value);
      setEffects(value);
    }

    SliderManager.setVolumeLevels(
     (100 - music) / 100,
     (100 - effects) / 100,
     (100 - master) / 100
    );
  };

  return (
    <div className="flex gap-6 p-6">
      <AudioSlider
        id="volumeRegion"
        label={<img src={musicIcon} alt="Music" className="w-6 h-6" />}
        value={music}
        onChange={(e) => handleChange("music", e.target.value)}
      />
      <AudioSlider
        id="volumeEffects"
        label={<img src={effectsIcon} alt="Effects" className="w-6 h-6" />}
        value={effects}
        onChange={(e) => handleChange("effects", e.target.value)}
      />
      <AudioSlider
        id="volumeMaster"
        label={<img src={masterIcon} alt="General" className="w-6 h-6" />}
        value={master}
        onChange={(e) => handleChange("master", e.target.value)}
      />
    </div>
  );
};

export default AudioControls;
